﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';

import config from '../../../common/config';

import tpl_paymentTerms_da_DK from './tpl/paymentTerms_da_DK.html';
import tpl_paymentTerms_en_GB from './tpl/paymentTerms_en_GB.html';


export default View_LayoutError.extend({
    getTemplate: function () {
        switch(config.cultureName()) {
            case 'da-DK' : return tpl_paymentTerms_da_DK({  }); break;
            case 'en-GB' : return tpl_paymentTerms_da_GB({  }); break;
            default: return tpl_paymentTerms_da_GB({  }); break;
        }
    },
    initialize: function () {
        this.app = this.options.app;
    },
    onBeforeShow: function () {
    },
    ui: {
    },
    events: {
    },
    onRender: function () {
    },
    onAttach(){
    },
    onDestroy(){
    }
}, Backbone.Radio.Requests);
